import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { Fragment, useEffect } from "react";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { DatePicker } from "@material-ui/pickers";
import DetalleDoctor from "./DetalleDoctor";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocInfoNumber from "../../../utils/MeditocInfoNumber";
import MeditocTable from "../../../utils/MeditocTable";
import RefreshIcon from "@material-ui/icons/Refresh";
import { getReporteDoctorColumns } from "../../../../models/ReporteDoctorModel";
import { useCatalogo } from "../../../../context/CatalogoContext";
import { useLogin } from "../../../../context/LoginContext";
import { useReporteDoctor } from "../../../../context/ReporteDoctorContext";

export default function ReporteDoctores() {
    const { usuarioPermisos } = useLogin();
    const { entCatalogos } = useCatalogo();
    const {
        listaEspecialidades,
        listaDoctores,
        doctorSeleccionado,
        formFiltro,
        entDoctores,
        handleChangeDoctorSeleccionado,
        handleChangeFormFiltroText,
        handleChangeFormFiltroDate,
        handleClickFiltrarDoctores,
        handleClickDescargarReporte,
        handleClickRefrescarDatos,
    } = useReporteDoctor();

    const permisos = usuarioPermisos["5"].Submodulos["2"];
    const { txtFechaDe, txtFechaA, txtTipoDoctor, txtEspecialidad, txtEstatusConsulta } = formFiltro;

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Descargar Reporte
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickDescargarReporte}>
                            <CloudDownloadIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Actualizar Reporte
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            {entDoctores && (
                <Fragment>
                    <MeditocBody>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <MeditocActions title="Filtrar doctores" />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <DatePicker
                                    name="txtFechaDe"
                                    label={txtFechaDe.label}
                                    value={txtFechaDe.value}
                                    onChange={(date) => handleChangeFormFiltroDate(date, "txtFechaDe")}
                                    InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                    inputVariant={inputVariant}
                                    format="dd/MM/yyyy"
                                    color={inputColor}
                                    variant="inline"
                                    fullWidth
                                    autoOk={true}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <DatePicker
                                    name="txtFechaA"
                                    label={txtFechaA.label}
                                    value={txtFechaA.value}
                                    onChange={(date) => handleChangeFormFiltroDate(date, "txtFechaA")}
                                    InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                    inputVariant={inputVariant}
                                    format="dd/MM/yyyy"
                                    color={inputColor}
                                    variant="inline"
                                    fullWidth
                                    autoOk={true}
                                />
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <TextField
                                    name="txtTipoDoctor"
                                    label={txtTipoDoctor.label}
                                    value={txtTipoDoctor.value}
                                    onChange={handleChangeFormFiltroText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    select
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {entCatalogos.catTipoDoctor.map((tipoDoctor) => (
                                        <MenuItem key={tipoDoctor.fiId} value={tipoDoctor.fiId}>
                                            {tipoDoctor.fsDescripcion}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <TextField
                                    name="txtEspecialidad"
                                    label={txtEspecialidad.label}
                                    value={txtEspecialidad.value}
                                    onChange={handleChangeFormFiltroText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    select
                                >
                                    <MenuItem value="">Todas las especialidades</MenuItem>
                                    {listaEspecialidades
                                        .sort((a, b) => (a.sNombre > b.sNombre ? 1 : -1))
                                        .map((especialidad) => (
                                            <MenuItem
                                                key={especialidad.iIdEspecialidad}
                                                value={especialidad.iIdEspecialidad.toString()}
                                            >
                                                {especialidad.sNombre}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <TextField
                                    name="txtEstatusConsulta"
                                    label={txtEstatusConsulta.label}
                                    value={txtEstatusConsulta.value}
                                    onChange={handleChangeFormFiltroText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    select
                                    SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 300 } } } }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {entCatalogos.catEstatusConsulta.map((estatus) => (
                                        <MenuItem key={estatus.fiId} value={estatus.fiId}>
                                            {estatus.fsDescripcion}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} className="right">
                                <Button
                                    variant="contained"
                                    style={{ color: "#555", marginRight: 15 }}
                                    onClick={handleClickRefrescarDatos}
                                >
                                    Limpiar filtro
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleClickFiltrarDoctores}>
                                    Filtrar doctores
                                </Button>
                            </Grid>
                            <Grid item md={4} sm={6} xs={12} className="center">
                                <MeditocInfoNumber
                                    label="TOTAL DE DOCTORES"
                                    value={entDoctores.iTotalDoctores}
                                    color="color-2"
                                />
                            </Grid>
                            <Grid item md={4} sm={6} xs={12} className="center">
                                <MeditocInfoNumber
                                    label="TOTAL DE CONSULTAS"
                                    value={entDoctores.iTotalConsultas}
                                    color="color-1"
                                />
                            </Grid>
                            <Grid item md={4} sm={6} xs={12} className="center">
                                <MeditocInfoNumber
                                    label="TOTAL DE PACIENTES"
                                    value={entDoctores.iTotalPacientes}
                                    color="color-3"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MeditocTable
                                    id="iIdDoctor"
                                    data={listaDoctores}
                                    row={doctorSeleccionado}
                                    columns={getReporteDoctorColumns()}
                                    setRow={handleChangeDoctorSeleccionado}
                                />
                            </Grid>
                        </Grid>
                    </MeditocBody>
                    <DetalleDoctor />
                </Fragment>
            )}
        </Fragment>
    );
}
